// Page Path : src\pages\design\document\configuration\secondary-screen.tsx

import { Box, CircularProgress } from '@mui/material';

import { useEffect, useState } from 'react';
import ImageViewerRightPane from './right-pane';
import { useVerificationImageViewer } from 'hooks/useVerificationImageViewer';
import { VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS, VerificationTechniquesType } from 'types/verification';

const SecondaryScreen = () => {
  const [initialised, setInitialised] = useState(false);
  const {
    currentPageDetails,
    setCurrentPageNumber,
    currentPageNumber,
    isLoadingImageBytes,
    searchTextInFile,
    fileLevelDetails,
    canvasFunctionRef,
    patternList,
    selectedPattern,
    fieldList,
    isVerifiedBatch,
    selectedFieldId,
    selectedTechniqueId,
    setSelectedFieldId,
    setSelectedTechniqueId,
    setSelectedPattern
  } = useVerificationImageViewer();

  useEffect(() => {
    window.addEventListener('message', (event) => {
      // Validate the origin of the message
      if (event.origin !== window.location.origin) {
        return;
      }
      const { type, payload } = event.data;
      switch (type) {
        case VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.LATEST_STATE:
        case VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.CLIENT_STATE_UPDATED:
          const { currentPageNumber, selectedFieldId, selectedTechniqueId, selectedPattern } = payload;
          setCurrentPageNumber(currentPageNumber);
          setSelectedFieldId(selectedFieldId);
          setSelectedTechniqueId(selectedTechniqueId);
          setSelectedPattern(selectedPattern, true);
          setInitialised(true);
          break;

        case VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.ON_SELECT_PATTERN: {
          setSelectedPattern(payload);
          break;
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCurrentPageNumber]);

  // get the latest client state from primary window for first time
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.GET_LATEST_STATE
        },
        window.location.origin
      );
    }
  }, []);

  const handleAddNewPattern = (payload: any) =>
    new Promise((resolve) => {
      if (window.opener) {
        window.opener.postMessage(
          {
            type: VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS.SUBMIT_ADD_EDIT_PATTERN,
            payload
          },
          window.location.origin
        );
      }
      resolve(true);
    });

  return (
    <Box className="image-viewer-secondary-screen">
      {initialised ? (
        <Box className="configuration-right-pane">
          <ImageViewerRightPane
            currentPageDetails={currentPageDetails}
            currentPageNumber={currentPageNumber}
            setCurrentPageNumber={setCurrentPageNumber}
            isSecondaryScreen
            currentFileId={selectedPattern?.fileID || 0}
            searchTextInFile={searchTextInFile}
            handleFileNavigation={() => () => undefined}
            isLoadingImageBytes={isLoadingImageBytes}
            fileLevelDetails={fileLevelDetails}
            canvasFunctionRef={canvasFunctionRef}
            patterns={patternList}
            finishAndMoveNextBatch={() => undefined}
            handleAddNewPattern={handleAddNewPattern}
            selectedPattern={selectedPattern}
            batchList={[]}
            selectedBatchId={0}
            selectedTechniqueName={
              (fieldList
                ?.find(({ fieldID }) => fieldID === selectedFieldId)
                ?.techniques?.find(({ techID }) => techID === selectedTechniqueId)
                ?.technique?.trim() || '') as VerificationTechniquesType
            }
            isVerifiedBatch={isVerifiedBatch}
            selectedFieldName={fieldList?.find(({ fieldID }) => fieldID === selectedFieldId)?.fieldName}
          />
        </Box>
      ) : (
        <Box className="configuration-loader-wrapper">
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default SecondaryScreen;
